import useLocale from '@/hooks/useLocale/useLocale';
import * as Styles from './ProductsList.styles';
import React from 'react';
import {
  Button, Icon404File, IconCodeGuard, IconSecurity, IconShield, PageTitle, Skeleton, Tag,
} from 'gatorcomponents';
import { format } from 'date-fns';
import { PRODUCT_NAMES } from '../../security.types';

const ProductsList = ({
  handleManageProductClick,
  productsListFiltered,
  getPageTitleProps,
  productsLoading,
  getStatus,
}) => {
  const { security: securityLocale } = useLocale();

  const handleManageProduct = (product) => {
    handleManageProductClick && handleManageProductClick(product);
  };

  const datePermitted = value => !['0000-00-00'].includes(value);

  const displayEmptyState = !productsListFiltered || !productsListFiltered.length;

  return (
    <>
      <Styles.FilterWrapper>
        <PageTitle {...getPageTitleProps()} />
      </Styles.FilterWrapper>

      <Styles.ProductsListWrapper>
        <Styles.ProductListDescription>
          {securityLocale.productsList.description}
        </Styles.ProductListDescription>
        <Styles.Divider />

        {productsLoading && (
          <Styles.ProductsListLoading>
            <Skeleton variant="tableSimple" />
          </Styles.ProductsListLoading>
        )}

        {!productsLoading && (
          <Styles.ProductListWrapper>
            {displayEmptyState && (
              <Styles.VisitsEmptyWrapper data-testid="courses-empty-state">
                <Styles.VisitsEmpty>
                  <Icon404File
                    secondaryColor="primaryLight"
                    size="xl"
                    testId="Icon404File"
                  />
                  <Styles.TitleEmpty>{securityLocale.productsList.emptyLabel}</Styles.TitleEmpty>
                </Styles.VisitsEmpty>
              </Styles.VisitsEmptyWrapper>
            )}
            {!displayEmptyState && productsListFiltered.map(product => (
              <Styles.Product key={product.id}>
                <Styles.ProductData data-testid={`product-${product.id}`}>
                  <Styles.ProductIdentify>

                    {product.name.toLowerCase().includes(PRODUCT_NAMES.sitelock) && <IconSecurity />}
                    {product.name.toLowerCase().includes(PRODUCT_NAMES.codeGuard) && <IconCodeGuard />}
                    {product.name.toLowerCase().includes(PRODUCT_NAMES.gatorProtect) && <IconShield />}

                    <Styles.ProductTitle>
                      {product.name}
                      <Styles.ProductDomain>{product.domain}</Styles.ProductDomain>
                    </Styles.ProductTitle>
                  </Styles.ProductIdentify>
                  <Styles.TagWrapper>
                    <Tag label={securityLocale.productsList.status[product.status]} variant={getStatus(product.status)} />
                  </Styles.TagWrapper>
                  {product.due_date && datePermitted(product.due_date) && (
                    <Styles.DueDate>
                      {format(new Date(`${product.due_date} 00:00:00`), 'dd/MM/yyyy')}
                      <Styles.DueText>
                        {securityLocale.productsList.due}
                      </Styles.DueText>
                    </Styles.DueDate>
                  )}
                  <Styles.ButtonWrapper>
                    {product.status === 'Active' && (
                      <Button
                        label={securityLocale.productsList.manage}
                        onClick={() => handleManageProduct(product)}
                        variant="secondary"
                      />
                    )}
                  </Styles.ButtonWrapper>
                </Styles.ProductData>

                <Styles.Divider />
              </Styles.Product>
            ))}
          </Styles.ProductListWrapper>
        )}
      </Styles.ProductsListWrapper>
    </>
  );
};

export default ProductsList;
